import { WebinarListState } from '../configs/types';

export const webinarListInitState: WebinarListState = {
  data: { retrieveWebinarResponse: [] },
  redDot: false,
  error: undefined,
};
